export { default } from "./routes/__public/forgot-password.tsx";